import React from 'react'
import Header from '../Components/Header';
import Sidebar from '../Components/Sidebar';

export default function EditCategory() {
         const handleSubmit = (e) => {
    e.preventDefault();
  };
  return (
 <div id="dashboard-root" 
      className="flex min-h-[1000px] w-full">
        {/* <!-- Sidebar --> */}
        <Sidebar />
        {/* <!-- Main Content --> */}
        <main id="main-content" className="flex-1 px-10 py-8">
          {/* <!-- Header --> */}
             <Header title="Edit Category" />
             <form onSubmit={handleSubmit}>
               <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6 p-8 bg-white">
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Category Name</label>
                        <input type="text" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500" value="Medications" />
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Parent Category (Optional)</label>
                        <select className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500">
                            <option selected="">None</option>
                            <option>Devices</option>
                            <option>Supplements</option>
                            <option>First Aid</option>
                        </select>
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                        <textarea rows="3" className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-500">All types of pharmaceutical medications and drugs</textarea>
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Icon</label>
                        <div className="grid grid-cols-6 gap-2 mt-2">
                            <button type="button" className="w-10 h-10 rounded-lg bg-primary-50 text-primary-600 flex items-center justify-center border-2 border-primary-500">
                                <i className="fa-solid fa-capsules"></i>
                            </button>
                            <button type="button" className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center hover:bg-primary-50 hover:text-primary-600">
                                <i className="fa-solid fa-pills"></i>
                            </button>
                            <button type="button" className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center hover:bg-primary-50 hover:text-primary-600">
                                <i className="fa-solid fa-tablets"></i>
                            </button>
                            <button type="button" className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center hover:bg-primary-50 hover:text-primary-600">
                                <i className="fa-solid fa-prescription-bottle"></i>
                            </button>
                            <button type="button" className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center hover:bg-primary-50 hover:text-primary-600">
                                <i className="fa-solid fa-stethoscope"></i>
                            </button>
                            <button type="button" className="w-10 h-10 rounded-lg bg-gray-100 flex items-center justify-center hover:bg-primary-50 hover:text-primary-600">
                                <i className="fa-solid fa-syringe"></i>
                            </button>
                        </div>
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
                        <div className="flex items-center space-x-4">
                            <label className="flex items-center">
                                <input type="radio" name="edit-status" className="mr-2 text-primary-600" checked="" />
                                <span>Active</span>
                            </label>
                            <label className="flex items-center">
                                <input type="radio" name="edit-status" className="mr-2 text-primary-600" />
                                <span>Inactive</span>
                            </label>
                        </div>
                    </div>
                    <div className="border-t pt-4 flex justify-end space-x-3">
                        <button type="button" className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700" id="cancel-edit-modal">Cancel</button>
                        <button type="submit" className="px-4 py-2 bg-primary-600 text-white rounded-lg">Save Changes</button>
                    </div>
                    </div>
                </form>
                </main>
    </div>
  )
}
